// API 配置文件
const getApiBaseUrl = () => {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;

  // 本地开发：前端 3000，后端 3001，避免依赖 Nginx 反代
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}:3001/api`;
  }

  // 生产环境：通过同域名 /api 访问，由 Nginx 转发到后端
  return `${protocol}//${hostname}/api`;
};

export const API_BASE_URL = getApiBaseUrl();

// 常用 API 端点（注意：API_BASE_URL 已包含 /api，所以这里不需要 /api 前缀）
export const API_ENDPOINTS = {
  WECHAT_WEB_AUTHORIZE: '/auth/wechat-web-authorize',
  SESSION: '/auth/session',
  PERMISSION_LATEST: '/permission-applications/latest',
  SITE_INFO: '/site/info',
  PROCESS_FLOW: '/process-flow',
  MQTT_VALUES: '/mqtt/values',
  MANUAL_UPLOAD: '/manual-upload',
  JINGHONG_PROCESS_LAYOUT: '/jinghong-process-layout',
};

// 构建完整的 API URL
export const buildApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
};
